'use client'
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react"

import Link from "next/link";



const CFooter = ({ footer }) => {
  return <footer className="block w-full">
    <div className="bg-dark-beige py-30px md:p-[40px] border-t-2 border-dark-grey md:flex md:justify-between">
      <div className="mb-4 md:mb-0">
        <Link href="/" aria-label="accueil" className="flex items-center">
          <span className="m-auto md:hidden">
            <img src='/svg/footer-logo-berkail-mobile.svg' loading="lazy" alt="Logo Berkail"/>
          </span>
          <span className="hidden md:block"><img src='/svg/footer-logo-berkail.svg' loading="lazy" alt="Logo Berkail"/></span>
        </Link>
      </div>
      <div className="flex border-2 border-dark-grey w-fit m-auto md:m-0">
        {footer.data.some.map((rs, i, array) => {
          console.log
          return <div key={i}>
            <PrismicLink field={rs.cta_url}
              className={`w-[40px] h-[40px] ${i < array.length - 1 ? 'border-r-2' : ''} border-dark-grey flex items-center justify-center social_btn`}>
              <PrismicImage field={rs.picto} loading="lazy" className="w-[40px] h-[40px]" />
            </PrismicLink>
          </div>
        })}
      </div>
    </div>
    <div className="bg-dark-grey md:flex">
      <div className="md:w-[350px] md:flex md:flex-col lg:block">
        <div className="px-4 py-30px md:p-[40px] lg:border-r-2 border-b-2 border-grey text-center md:text-start">
          <PrismicRichText field={footer.data.text} />
        </div>
        <div className="px-4 py-30px md:p-[40px] border-b-2 md:border-b-0 lg:border-r-2 border-grey">
          <div className="m-auto w-fit mb-30px">
            <PrismicLink field={footer.data.cta_page} className="cta_form text-center w-[270px] button button-footer button-text bg-beige hover:bg-transparent text-dark-grey hover:text-beige">
              {footer.data.cta_label}
            </PrismicLink>
          </div>
          <div className="m-auto w-fit mb-30px">

            <a href={`tel:${footer.data.tel}`}
              className="text-center w-[270px] button button-footer button-text hover:bg-beige text-beige hover:text-dark-grey phone_btn">
              {footer.data.tel}</a>
          </div>
          <div className="m-auto">
            <Link href="/" aria-label="accueil" className="flex items-center flex flex-col">
              <span className="m-auto mb-2">
                <PrismicImage field={footer.data.picto}
                  className="h-[14px] w-[110px] object-contain"  loading="lazy"/>
              </span>
              <p className="text-center text-google"> {footer.data.note}</p>
            </Link>
          </div>
        </div>
        <div className="px-4 h-full py-30px border-t-2 border-grey hidden md:block lg:hidden">
          <div className="flex grid grid-cols-2 h-full justify-center items-center gap-y-8">
            {
              footer.data.partenaires.map((partners, i, array) => {
                <div>
                  <PrismicLink field={partners.cta_url}>
                    <PrismicImage field={partners.picture} loading="lazy"
                      className="w-3/4 m-auto object-contain" />
                  </PrismicLink>
                </div>
              })
            }
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col justify-between md:border-l-2 border-grey">
        <div
          className="text-beige w-full flex grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-5 lg:gap-x-5 justify-between px-4 md:px-[40px] py-[40px]">
          {
            footer.data.slices.map(({ primary }, i, array) => {
              return <div key={i} className={i < array.length - 1 ? '' : 'col-span-full lg:col-auto'}>
                <h4 className="mb-4 text-beige">{primary.title}</h4>
                <ul>
                  {primary.links.map((subItems, j, arr) => {
                    if (arr[i].cta_label !== 'Cookies') {
                      return <li key={j} className="mb-3">
                        <PrismicLink field={subItems.cta_page}>
                          {subItems.cta_label}
                        </PrismicLink>
                      </li>
                    } else {
                      return <li key={j} className="mb-3">
                        <a href="javascript:window.Sddan.cmp.displayUI();">
                          {subItems.cta_label}
                        </a>
                      </li>
                    }
                  })}
                </ul>
              </div>
            })}
        </div>
        <div className="flex flex-wrap lg:flex-nowrap border-t-2 border-grey">
          {/* <!-- Multilangue enlever le w-full + hidden --> */}
          <div className="w-4/5 w-full py-5 px-14 md:border-r-2 border-grey lg:w-auto">
            <p className="credits text-center">we speak english</p>
          </div>
          <div
            className="hidden w-1/5 flex flex-row items-center lg:border-r-2 border-grey justify-center lg:w-auto lg:px-6">
            <p className="mr-1"> FR </p>
            <img src='/svg/arrow-footer.svg' loading="lazy"/>
          </div>
          <div className="m-auto border-t-2 border-grey lg:border-t-0 px-16 py-5 lg:py-0 lg:px-5">
            <p className="credits text-center">site web réalisé avec amour et pixels par <a href="https://www.aztk.io/"
              target="_blanc">AZTK</a> et <a href="https://www.faustinenajman.com/" target="_blank">Faustine Najman</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="w-full bg-dark-grey px-4 py-30px lg:p-[40px] border-t-2 border-grey md:hidden lg:block">
      <div className="flex grid grid-cols-3 lg:grid-cols-6 max-w-[1400px justify-center gap-10 lg:gap-5">
        {
          footer.data.partenaires.map((partner, i, array) => {
            return <div key={i}>
              <PrismicLink field={partner.cta_url}>
                <PrismicImage field={partner.picture} loading="lazy" className="w-3/4 md:w-2/3 m-auto h-[60px] object-contain" />
              </PrismicLink>
            </div>
          })}
      </div>
    </div>
  </footer >
}

export default CFooter